import { type FunctionComponent } from 'react';

export type ModelProps = {
	modelNumber: string;
	truncate?: boolean;
	className?: string;
};

export const Model: FunctionComponent<ModelProps> = ({ modelNumber, truncate = true, className = '' }) => {
	return <div className={`f6 lh-title theme-grey ${truncate ? 'truncate' : ''} ${className}`}>Model: {modelNumber}</div>;
};
